import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Gallery from "@/components/landing/Gallery";
import Flavors from "@/components/landing/Flavors";
import Manifesto from "@/components/landing/Manifesto";
import OrderForm from "@/components/landing/OrderForm";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-black">
      <Header />
      <Hero />
      <Marquee />
      <Gallery />
      <Flavors />
      <Manifesto />
      <OrderForm />
      <Faq />
      <Footer />
    </main>
  );
}
